export const projectData = [
    {
        "id": 1,
        "projectName": "Movie library",
        "tech": "MERN, Bootstrap, API",
        "description":"Discover movies and TV shows with ease on our website. You can find information on the cast, trailer and more, and use search and filter functions to refine your options. Bookmark a movie to watch later for easy access.",
        "live": "https://www.linkedin.com/posts/nilesh-lad-476216216_api-mernstack-project-activity-6959163211371675648-mbYB?utm_source=linkedin_share&utm_medium=member_desktop_web",
        "source": "https://github.com/nileshlad09/movielibrary",
        "color": "#A5F3FC",
        "color2": "#174F64"
    },
    {
        "id": 2,
        "projectName": "TrackZ",
        "tech": "MERN, Material UI",
        "description": "Connect directly with local hawkers on our platform. Send notifications to request service and receive personalized attention. Say goodbye to waiting and enjoy a convenient experience. Join us today for an innovative solution to hawker services.",
        "live": "",
        "source": "https://github.com/nileshlad09/TrackZ",
        "color": "#FECDD3",
        "color2": "#881337"
    },
    {
        "id": 3,
        "projectName": "WordWizard",
        "tech": "React Js, Bootstrap",
        "description": "Effortlessly analyze text on our platform. Transform case, remove extra spaces, and more. Get word count and reading time for a streamlined experience.",
        "live": "https://nileshlad09.github.io/textanalysis/",
        "source": "https://github.com/nileshlad09/textanalysis",
        "color": "#FDE68A",
        "color2": "#78350F"
    },
    {
        "id": 4,
        "projectName": "Tourism Management System",
        "tech": "Java Swing, MySQL workbench",
        "description": "Manage your tourism needs with our system. Bookings, itinerary planning, and organization made easy. Discover stress-free travel with our innovative solution.",
        "live": "",
        "source": "https://github.com/nileshlad09/travel_and_tourism_management_system/tree/main/java%20project",
        "color": "#BFDBFE",
        "color2": "#1E3A8A"
    },
    {
        "id": 5,
        "projectName": "ForecastMate",
        "tech": "HTML5, CSS3, JavaScript",
        "description": "Stay informed about the weather with our app. Get current location details and search for specific locations. Enjoy ease of use with our one-click feature.",
        "live": "",
        "source": "https://github.com/nileshlad09/weather-app",
        "color": "#A5F3FC",
        "color2": "#174F64"
    },
    {
        "id": 6,
        "projectName": "Scribblespace",
        "tech": "ReactJs, Bootstarp",
        "description": "Organize your notes easily with our website. Create, edit, and delete sticky notes, and search for them by name or filter them by tags. Stay on top of your notes and boost your productivity with our intuitive platform.",
        "live": "",
        "source": "https://github.com/nileshlad09/notebook09",
        "color": "#FECDD3",
        "color2": "#881337"
    },
]
